"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectKeys = exports.objectEntries = exports.deepFreeze = void 0;
/**
 * Freeze objects recursively.
 * DO NOT use on any object with a Vue component as a value
 * as you'll run into an infinite recursion loop!
 */
function deepFreeze(object) {
    // Retrieve the property names defined on object
    var propNames = Reflect.ownKeys(object);
    // Freeze properties before freezing self
    for (var _i = 0, propNames_1 = propNames; _i < propNames_1.length; _i++) {
        var name_1 = propNames_1[_i];
        var value = object[name_1];
        if ((value && typeof value === 'object') || typeof value === 'function') {
            deepFreeze(value);
        }
    }
    return Object.freeze(object);
}
exports.deepFreeze = deepFreeze;
/** Same as `Object.entries` but doesn't lose type information. */
function objectEntries(obj) {
    return Object.entries(obj);
}
exports.objectEntries = objectEntries;
/** Same as `Object.keys` but doesn't lose type information. */
function objectKeys(obj) {
    return Object.keys(obj);
}
exports.objectKeys = objectKeys;
